
import Vue from 'vue';
import WebText from '../Text/Text.vue';
import ArrowDown from '../../Icons/ArrowDown.vue';
import ArrowDownLight from '../../Icons/ArrowDownLight.vue';
/**
 * SelectBox Component.
 *
 * A dropdown menu without search.
 */
type SelectItem = {
  label: string;
  value: string;
};
export default Vue.extend<any, any, any, any>({
  name: 'SelectBox',
  components: {
    ArrowDown,
    ArrowDownLight,
    WebText
  },
  props: {
    /**
     * Value of the Select.<br />
     * When using v-model, the props will be ignored.
     */
    value: {
      type: [String, Object],
      default: '',
      required: true
    },
    /**
     * Select list options.<br />
     * Model of the list:
     *
     * - label: label of the opsion.
     * - value: an unique identifier value.
     */
    items: {
      type: Array,
      default: () => [] as SelectItem[],
      required: true
    },
    /**
     * Placeholder of Select.
     */
    tittle: {
      type: String,
      default: 'Select Option'
    },
    /**
     * Border CSS of the Select.
     */
    border: {
      type: String,
      default: '1px solid #E2E2E2'
    },
    /**
     * Width of the Select.
     */
    width: {
      type: String,
      default: '100%'
    },
    /**
     * Shadow of the Select.<br />
     * Possible value `flat` | `container` | `interactive`
     * | `float` | `hover`<br />
     * From left to right, shadow will be bigger
     */
    elevation: {
      type: Boolean,
      default: false
    },
    /**
     * Show list options in upper instead of bottom of Select
     */
    upperMenu: {
      type: Boolean,
      default: false
    },
    /**
     * To make selectbox fit on the left side of Input component.
     */
    additionSelectBox: {
      type: Boolean,
      default: false
    },
    /**
     * Make content of the Select bold.
     */
    bold: {
      type: Boolean,
      default: false
    },
    /**
     * Show error state in Select.
     */
    error: {
      type: Boolean,
      default: false
    },
    /**
     * Show the first options as a value if not have value.
     */
    placeholderDefaultValue: {
      type: Boolean,
      default: false
    },
    /**
     * Will trigger click without opening dropdown.
     */
    clickOnly: {
      type: Boolean,
      default: false
    },
    /**
     * Color of the icon.
     */
    fill: {
      type: String,
      default: '#fff'
    },
    /**
     * Color of the arrow icon select.
     */
    arrowFill: {
      type: String,
      default: '#bababa'
    },
    /**
     * Required property.
     */
    required: {
      type: Boolean,
      default: false
    },
    /**
     * Text variant of Select.
     */
    variant: {
      type: String,
      default: ''
    },
    /**
     * Ink text of Select.
     */
    ink: {
      type: String,
      default: 'highlight'
    }
  },
  data() {
    return {
      openSelections: false,
      selected: false
    };
  },
  computed: {
    computedLabel() {
      if (this.placeholderDefaultValue && !this.selected) {
        return this.items[0].label;
      }
      const labelSearch = (this.items as SelectItem[]).find(item => {
        return this.value === item.value;
      });
      if (labelSearch) return labelSearch.label;
      return this.tittle;
    },
    computedBorder() {
      if (this.additionSelectBox) {
        return 'none';
      } else {
        return this.border;
      }
    }
  },
  methods: {
    activate(e: Event) {
      if (this.clickOnly) {
        /**
         * Handle when click the Select.
         * @event click
         * @type {function}
         */
        this.$emit('click', e);
      } else {
        if (this.openSelections) {
          this.deactivate();
        } else {
          (this.$el as HTMLElement).focus();
          this.openSelections = true;
        }
      }
    },
    deactivate() {
      this.openSelections = false;
      if (this.required) {
        /**
         * Handle error state of Select.
         * @event inputState
         * @type {function}
         */
        this.$emit('inputState', this.selected ? true : false);
      }
      (this.$el as HTMLElement).blur();
    },
    selectValue(value: string) {
      this.selected = true;
      this.deactivate();
      if (!this.border) {
        this.border = '1px solid var(--uiGrayLight)';
      }
      /**
       * Handle when value changed.
       * @event input
       * @type {function}
       */
      this.$emit('input', value);
      /**
       * Handle when value changed.
       * @event change
       * @type {function}
       */
      this.$emit('change', value);
    }
  }
});
